export interface IMovementCreditSummary {
  totalCreditBalance: number;
  housesWithCredit: number;
}

export class MovementCreditSummary implements IMovementCreditSummary {
  totalCreditBalance: number;
  housesWithCredit: number;

  constructor(data: IMovementCreditSummary) {
    this.totalCreditBalance = data.totalCreditBalance ?? 0;
    this.housesWithCredit = data.housesWithCredit ?? 0;
  }
}
